var $ = require('jquery');
var features = require('diy/util/features');

/**
 * UpgradeLayer
 * provides functionality for displaying upgrade dialog
 * and defining editor elements that need an upgrade before use
 *
 * code was in most part copied from ActiveAdd
 *
 * Author: gpopescu
 * @depends diy.simpletooltip.js
 * @depends diy.dialog.js
 * @depends jimdoData.messages
 */

(function() {
    var self = this;
    var selector = "[data-oao-upgrade=true]";
    this.getSelector = function() {
        return selector;
    };
    this.isElementUpgradable = function(element) {
        return $(element).is(selector);
    };
    this.initButtons = function() {
        $(this.getSelector())
            .mousemove($.proxy(this.showTooltip, this))
            .mouseout($.proxy(this.onBtnOut, this))
            .mousedown($.proxy(this.showWindow, this));
        $(window).scroll($.proxy(this.onBtnOut, this));
    };
    this.onBtnOut = function(evt) {
        // NOTE: caller event has context added
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
        }
    };
    this.showTooltip = function(evt) {

        var content = jimdoData.tariffUpdate ?
            jimdoData.messages.conf_AddMenu_tariffUpdate_info
            : jimdoData.messages.conf_AddMenu_upgrade_info;
        // We need a dummy element to bind the tooltip instance to
        // Sharing a tooltip instance for all instances of upgradeLayer
        if (!self._tooltipCt) {
            self._tooltipCt = $('<div />').diy_simpleTooltip({
                anchorToTarget: false,
                trackMouse: true,
                zIndex: 200000,
                cls: 'diy-info-tooltip',
                position: {
                    collision: 'fit'
                },
                triggerMode: 'none',
                content: content
            });
        }
        self._tooltipCt.diy_simpleTooltip('show', evt);
    };
    this.hideUpgradeLayer = function() {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
            self._tooltipCt.diy_simpleTooltip('destroy');
            self._tooltipCt = null;
        }
    };
    this.showWindow = function(e) {
        if (jimdoData.tariffUpdate) {
            return this.showTariffUpdateWindow(e);
        } else {
            return this.showUpgradeWindow(e);
        }
    };
    this.showTariffUpdateWindow = function(e) {
        var upgradeTarget, from;
        upgradeTarget = $(e.currentTarget);
        diy.editor.tariffUpdate.openPopup({
            component: upgradeTarget.attr('data-oao-upgrade-from-component'),
            control: upgradeTarget.attr('data-oao-upgrade-from-control')
        });
    };
    this.showUpgradeWindow = function() {
        /*display the jquery dialog*/
        $("#upgrade-window")
            .removeClass('hidden')
            .diy_dialog({
                title: jimdoData.messages.conf_AddMenu_upgrade_window_title,
                modal: true,
                width: 720,
                draggable: false,
                buttons: [{
                    text: jimdoData.messages.conf_AddMenu_upgrade_window_package_selection,
                    click: function(){
                        var upgrade_link = false;;
                        if (diy.tracking) {
                            upgrade_link = diy.pfcSupport.setLinkParamToString(
                                jimdoData.messages.conf_AddMenu_upgrade_window_package_selection_link,
                                13
                            );
                        }
                        if (!upgrade_link) {
                            upgrade_link = jimdoData.messages
                                .conf_AddMenu_upgrade_window_package_selection_link;
                        }
                        //simulate click
                        window.open(upgrade_link, '_blank');
                    }
                },{
                    text: jimdoData.messages.conf_AddMenu_upgrade_window_cancel_label,
                    "class": "button-cancel",
                    click: function(){
                        $("#upgrade-window").diy_dialog("close");
                    }
                }],
                resizable: false
            })
        ;
        this.hideUpgradeLayer();
        /* track that the upgrade window was opened */
        jQuery(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'upgrade-window'
        });
    };
    this.openUpgradePopup = function() {
        var upgrade_link = false;
        if (diy.tracking) {
            upgrade_link = diy.pfcSupport.setLinkParamToString(
                jimdoData.messages.conf_AddMenu_upgrade_window_package_selection_link,
                13
            );
        }
        if (!upgrade_link) {
            upgrade_link = jimdoData.messages
                .conf_AddMenu_upgrade_window_package_selection_link;
        }
        //simulate click
        window.open(upgrade_link, '_blank');
    };
    this.onUpgradeInfoLinkClicked = function() {
        if (!features('upsellDirectLink')) {
            this.showWindow();
        } else {
            this.openUpgradePopup();
        }
    };
}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/common/js/UpgradeLayer.js
 ** module id = 1135
 ** module chunks = 0
 **/